export var tableHeaderContainer = {
  padding: '1em 0'
};
export var footerContainer = {
  padding: '1em 2em',
  display: 'flex',
  justifyContent: 'flex-end'
};
export var modalContent = {
  minWidth: '400px'
};
export var reportItem = {
  padding: '0.5em 0',
  borderBottom: '1px solid #eee',
  '& > p:first-of-type': {
    fontWeight: 500
  }
};
export var totalAmount = {
  padding: '1em 0',
  marginBottom: '1em',
  borderTop: '2px solid #333',
  '& > p:first-of-type': {
    fontWeight: 600,
    marginBottom: '0.5em'
  }
};